import { render } from "./green-gradient-provider.svg?vue&type=template&id=3987f878"
const script = {}
script.render = render

export default script